import { useEffect, useState } from 'react';

/*
    Web components have an issue with late loading of styling, which results of a flash of unstyled component (FOUC).
    This hook is a simple fix, with a timeout we're hiding the component for a few millisec so that the CSS is given time to load. 
*/
const useHideFouc = () => {
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 50);
    }, []);
    return loading;
};

export default useHideFouc;
